<template>
  <v-card>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text>
      <v-container fluid class="jwt-scanner">
        <v-row>
          <v-col>
            <v-text-field outlined
                          :hint="$t('jwt_scanner.scanner_hint')"
                          persistent-hint
                          autofocus
                          autocomplete="off"
                          ref="jwtInput"
                          @keyup.enter="onEnter"
                          class="jwt-scanner-input"
                          :disabled="qrCodeReaderSuspended"
                          v-model="jwt"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-divider></v-divider>
          <span class="mx-4">{{ $t('jwt_scanner.or') }}</span>
          <v-divider></v-divider>
        </v-row>
        <QrcodeStream :camera="qrCodeReaderSuspended? 'off' : 'auto'"
                      @decode="onDecode"
                      class="qr-code-reader">
          <div class="qr-code-reader-overlay" v-if="qrCodeReaderSuspended">
            <label>PROCESSING...</label>
          </div>
        </QrcodeStream>
        <h5 class="text-center">{{ $t('jwt_scanner.webcam_label') }}</h5>
        <v-row v-if="manualInputKey">
          <v-divider></v-divider>
          <span class="mx-4">{{ $t('jwt_scanner.or') }}</span>
          <v-divider></v-divider>
        </v-row>
        <v-row v-if="manualInputKey">
          <v-col>
            <v-text-field outlined
                          :label="manualInputLabel"
                          :hint="$t('jwt_scanner.manual_input_hint')"
                          persistent-hint
                          autocomplete="off"
                          @keyup.enter="onManualInputEnter"
                          v-model="manualInput"></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="cancel"
             class="mr-3"
             depressed
             large>
        {{ $t('cancel') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import BGModal from "@/components/BGModal";
import {onMounted, ref} from "@vue/composition-api";
import {QrcodeStream} from 'vue-qrcode-reader'
import $ from 'jquery'

export default {
  name: 'JwtScanner',
  components: {BGModal, QrcodeStream},
  props: {
    targetKey: {
      type: [String, Array],
      default: 'sub',
    },
    title: String,
    manualInputKey: [String, Array],
    manualInputLabel: String,
    skipDecode: Boolean,
  },
  setup(props, {root, emit}) {
    // Init
    const cancel = function () {
      emit('submit', undefined);
    };

    const processing = ref(false);

    const verifyJwt = function (token) {
      root.$callAPI('aafb/admin/jwt/', {token}, (response) => {
        emitResult(response);
      }, (response) => {
        if (response.status === 401 || response.status === 302) {
          root.$storeDispatch('logout');
          // v.$router.push({name: 'login'});

          root.$eventHub.$emit('logout');
          return;
        } else if (typeof response.body === 'object') {
          if ('msg' in response.body) {
            let msg = response.body.msg;

            if (root.$te('error_messages.' + msg)) {
              root.$showAlertMessage(root.$t('error_messages.' + msg));
              return
            } else {
              root.$showAlertMessage(msg);
              return
            }
          }
        }
        root.$showAlertMessage(root.$t('error_messages.default'));

        cancel();
      })
    }

    //
    const jwtInput = ref();
    const jwt = ref(null);
    const onEnter = function () {
      qrCodeReaderSuspended.value = true;

      verifyJwt(jwt.value);
    }

    const qrCodeReaderSuspended = ref(false);
    const onDecode = function (token) {
      qrCodeReaderSuspended.value = true;

      verifyJwt(token);
    }

    const manualInput = ref(null);
    const onManualInputEnter = function () {
      if (manualInput.value) {
        if (props.manualInputKey instanceof Array) {
          let result = {};

          props.manualInputKey.forEach((k) => {
            result[k] = manualInput.value
          })

          emit('submit', result);
        } else {
          emit('submit', manualInput.value);
        }
      }
    }

    const emitResult = function (response) {
      if (props.targetKey instanceof Array) {
        let result = {};

        props.targetKey.forEach((k) => {
          result[k] = response.body[k]
        })

        emit('submit', result);
      } else {
        emit('submit', response.body[props.targetKey]);
      }
    }

    onMounted(() => {
      setTimeout(() => {
        jwtInput.value.focus();
        $('.jwt-scanner-input input').focus();
      }, 500)
    })

    return {
      cancel,

      processing,

      jwtInput,
      jwt,
      onEnter,

      qrCodeReaderSuspended,
      onDecode,

      manualInput,
      onManualInputEnter,
    }
  }
}
</script>

<style lang="less">
.jwt-scanner {
  .qr-code-reader-overlay {
    display: inline-table;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);

    label {
      display: table-cell;
      vertical-align: middle;
      text-align: center;
      color: white;
    }
  }
}
</style>
